import { createFileRoute } from "@tanstack/react-router";
import RevisionSheetsGuideFr from "@/pages/resources/fr/RevisionSheetsGuideFr";

export const Route = createFileRoute("/fr/learn/revision-sheets")({
  head: () => ({
    meta: [
        {
            "title": "Comment créer des fiches de révision efficaces | System Atlas"
        },
        {
            "name": "description",
            "content": "Un cadre pratique pour créer des fiches de révision qui améliorent la rétention. Structure, mise en forme et stratégies de contenu."
        },
        {
            "property": "og:title",
            "content": "Comment créer des fiches de révision efficaces | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Un cadre pratique pour créer des fiches de révision qui améliorent la rétention. Structure, mise en forme et stratégies de contenu."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/revision-sheets"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Comment créer des fiches de révision efficaces | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Un cadre pratique pour créer des fiches de révision qui améliorent la rétention. Structure, mise en forme et stratégies de contenu."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/revision-sheets"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/revision-sheets"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/revision-sheets"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/revision-sheets"
        }
    ],
  }),
  component: RevisionSheetsGuideFr,
});
